"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidetip = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.drule)({
    ...nano_theme_1.lightTheme.font.ui3.mid,
    fz: '15px',
    letterSpacing: '-0.025em',
});
const blockSmallClass = (0, nano_theme_1.rule)({
    ...nano_theme_1.lightTheme.font.ui1.mid,
    fz: '13px',
});
const Sidetip = ({ small, children }) => {
    const styles = (0, context_1.useStyles)();
    return React.createElement("span", { className: blockClass({ col: styles.g(0.5) }) + (small ? ' ' + blockSmallClass : '') }, children);
};
exports.Sidetip = Sidetip;
